import { CoachSkillTypeId } from './../../adminv3/types/session';
import { MainV3ApiBase, CommonsV1ApiBase } from './base';
import { ReviewerIndexView } from '../types/reviewers';

export const ReviewerApis = {
  findAll(
    query: string,
    coachSkillTypeIds: CoachSkillTypeId[] | null = null,
    limit = 10
  ): Promise<ReviewerIndexView[]> {
    const serializedCoachSkillTypeIds: string | null = coachSkillTypeIds ? coachSkillTypeIds.join(',') : null;
    return MainV3ApiBase.appendPath('reviewers').get({
      query,
      coach_skill_type_ids: serializedCoachSkillTypeIds,
      limit,
    });
  },
  find(staff_id: number): Promise<ReviewerIndexView> {
    return MainV3ApiBase.appendPath('reviewers').withId(staff_id).get();
  },
};

export const CommonsV1ReviewerApis = {
  base() {
    return CommonsV1ApiBase.appendPath('reviewers');
  },
  findAll(coachSkillTypeName: string): Promise<ReviewerIndexView[]> {
    return this.base().get<ReviewerIndexView[]>({
      coach_skill_type_name: coachSkillTypeName,
    });
  },
};
